import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Button } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

/**
 * "Back" to the previous step of the re-enrolment flow.
 *
 * Parents had no way back from any screen. The only ArrowBack buttons in the flow were inside Parent
 * Information, moving between each student's medical screen — nothing stepped back to the screen
 * before. A parent who answered something wrongly had to sign out and start again.
 *
 * Deliberately not on the payment screens or anything after them. Returning from /payment re-enters
 * the fee flow, which re-quotes the family and can write another session; leaving the card form can
 * abandon a payment that is already in flight; and after payment there is nothing useful to go back
 * to. The form screens carry none of that risk — they re-read what the server already holds.
 *
 * `state` is passed on rather than dropped, because every screen in the flow reads ParentID,
 * college, credit_amount and isGhostLogin out of the router state. Navigating without it lands the
 * parent on a screen that cannot tell who they are, which is how a "Back" button turns into a
 * dead end. The caller passes its own location.state, which is always a superset of what the
 * previous screen needs.
 */
const StepBackButton = ({ to, label = 'Back', state }) => {
    const navigate = useNavigate();
    const location = useLocation();

    return (
        <Button
            startIcon={<ArrowBackIcon />}
            onClick={() => navigate(to, { state: state === undefined ? location.state : state })}
            sx={{ color: '#059669', fontWeight: 700, textTransform: 'none' }}
        >
            {label}
        </Button>
    );
};

export default StepBackButton;
